import * as types from '../../mutation-types'
/*
import charts from './charts'
import uifeatures from './uifeatures'
import components from './components'
import tables from './tables'
*/
import fixtures from './fixtures'
// import season from './season'
import lazyLoading from './lazyLoading'
// show: meta.label -> name
// name: component name
// meta.label: display label

const state = {
  items: [
    // {
    //   name: 'League Player Stats',
    //   path: '/stats/player-equiv',
    //   meta: {
    //     auth: true,
    //     icon: 'fa-line-chart',
    //     link: 'stats/player-equivalency.vue'
    //   },
    //   component: lazyLoading('stats/player-equivalency')
    // },
    {
      name: 'Season Stats',
      path: '/season-stats/season-stats-22',
      meta: {
        auth: true,
        icon: 'fa-line-chart',
        link: 'stats/season-stats/season-stats-22.vue'
      },
      component: lazyLoading('stats/season-stats/season-stats-22')
    },
    {
      name: 'OLD Season Stats',
      path: '/season-stats/overview',
      meta: {
        auth: true,
        icon: 'fa-line-chart',
        link: 'stats/season-stats/overview.vue'
      },
      component: lazyLoading('stats/season-stats/overview')
    },

    fixtures,
    {
      name: 'Teams',
      path: '/teams/',
      meta: {
        auth: true,
        icon: 'fa-users',
        link: 'teams/teams.vue'
      },
      component: lazyLoading('teams/teams')
    },
    {
      name: 'Player Manager',
      path: '/editors/team-editor',
      meta: {
        auth: true,
        icon: 'fa-users',
        link: 'editors/team-editor.vue'
      },
      component: lazyLoading('editors/team-editor')
    }
  ]
}

const mutations = {
  [types.EXPAND_MENU] (state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/index.js